import data from "../../../../data/schema/shared/sharedData";

export default {
  name: "Worker Housing Profile",
  sections: [
    {
      name: "Worker Housing Profile",
      fields: [
        {
          isGroup: {
            machine_name: "new_profile_worker_housing_type_of_housing",
            label: "Type of Housing",
            required: true,
            coloring: "none",
            fields: [
              {
                widget: "radio",
                machine_name: "new_profile_worker_housing_type_of_housing",
                choice: "Employer-provided (including mobile or range)",
                value: "Employer",
                validate: ["required"],
              },
              {
                widget: "radio",
                machine_name: "new_profile_worker_housing_type_of_housing",
                choice: "Rental or public accommodations",
                value: "Rental",
                validate: ["required"],
              },
            ],
          },
        },
        {
          machine_name: "new_profile_worker_housing_physical_location_address",
          label: "Physical Location - Address/Location",
          maxLength: 60,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Bad format: Address/Location must contain at least 5 characters.",
            },
          ],
        },
        {
          machine_name: "new_profile_worker_housing_physical_location_city",
          label: "Physical Location - City",
          maxLength: 35,
          validate: [
            {
              minLength: 2,
              message: "Bad format: City must contain at least 2 characters.",
            },
          ],
        },
        {
          machine_name: "new_profile_worker_housing_physical_location_state",
          label: "Physical Location - State",
          widget: "select",
          selection: data.state,
          state: true,
          validate: ["required"],
        },
        {
          machine_name: "new_profile_worker_housing_physical_location_county",
          label: "Physical Location - County",
          widget: "countyselect",
          required: true,
          validate: [
            "required",
            {
              required_county:
                "new_profile_worker_housing_physical_location_state",
              message: "",
              needsFieldValues: true,
            },
          ],
          disabled: true,
          disableWhenField:
            "new_profile_worker_housing_physical_location_state",
        },
        {
          machine_name: "new_profile_worker_housing_physical_location_zip_code",
          label: "Physical Location - Postal Code",
          widget: "text",
          maxLength: 10,
          validate: ["postalUSA"],
        },
        {
          machine_name:
            "new_profile_worker_housing_additional_housing_information",
          label: "Additional Housing Information",
          widget: "text_area",
          width: 8,
          rows: 10,
          inputLimit: 500,
          validate: [
            {
              minLength: 5,
            },
            {
              maxLength: 500,
            },
          ],
        },
        {
          machine_name: "new_profile_worker_housing_total_units",
          label: "Total Units",
          widget: "text",
          maxLength: 4,
          parse: "positiveWholeNumber",
          validate: ["required", "number"],
        },
        {
          machine_name: "new_profile_worker_housing_total_occupancy",
          label: "Total Occupancy",
          widget: "text",
          maxLength: 4,
          parse: "positiveWholeNumber",
          validate: ["required", "number"],
        },
        {
          isGroup: {
            label:
              "Identify the entity that determined the housing met all applicable standards:",
            coloring: "none",
            disabled: true,
            columns: false,
            required: true,
            machine_name:
              "new_profile_worker_housing_applicable_housing_standards",
            fields: [
              {
                widget: "checkbox_old",
                machine_name:
                  "new_profile_worker_housing_applicable_housing_standards_local",
                choice: "Local Authority",
                label: "Local",
                hidden: true,
                value: "YES",
                validate: [
                  {
                    subsetOfSetRequired:
                      "new_profile_worker_housing_applicable_housing_standards",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      numRequired: 1,
                      fieldArray: [
                        "new_profile_worker_housing_applicable_housing_standards_local",
                        "new_profile_worker_housing_applicable_housing_standards_swa",
                        "new_profile_worker_housing_applicable_housing_standards_other_state",
                        "new_profile_worker_housing_applicable_housing_standards_other",
                        "new_profile_worker_housing_applicable_housing_standards_federal",
                      ],
                    },
                  },
                ],
              },
              {
                widget: "checkbox_old",
                machine_name:
                  "new_profile_worker_housing_applicable_housing_standards_swa",
                choice: "SWA",
                label: "SWA",
                value: "YES",
                hidden: true,
              },
              {
                widget: "checkbox_old",
                machine_name:
                  "new_profile_worker_housing_applicable_housing_standards_other_state",
                choice: "Other State Authority",
                label: "Other State",
                value: "YES",
                hidden: true,
              },
              {
                widget: "checkbox_old",
                machine_name:
                  "new_profile_worker_housing_applicable_housing_standards_federal",
                choice: "Federal Authority",
                label: "Federal",
                value: "YES",
                hidden: true,
              },
              {
                widget: "checkbox_old",
                machine_name:
                  "new_profile_worker_housing_applicable_housing_standards_other",
                choice: "Other (Specify)",
                label: "Other (Specify)",
                value: "YES",
                hidden: true,
                clearSchema: [
                  "new_profile_worker_housing_applicable_housing_standards_other_text",
                ],
              },
            ],
          },
        },
        {
          label: "Specify: ",
          machine_name:
            "new_profile_worker_housing_applicable_housing_standards_other_text",
          widget: "text_area",
          width: 4,
          rows: 2,
          inputLimit: 25,
          validate: ["required"],
          isVisible: {
            when: "new_profile_worker_housing_applicable_housing_standards_other",
            is: "YES",
          },
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_profile_worker_housing_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          maxLength: 50,
          validate: ["required"],
          tooltip:
            "Enter a unique name that will allow you to identify this profile",
        },
      ],
    },
  ],
};
